import { gql } from 'graphql-request'

export const PENDING_ITEMS_HANDOFF_QUERY_KEYS = {
  equipmentReadiness: 'PENDING_ITEMS_EQUIPMENT_READINESS',
  equipmentReadinessBatch: 'PENDING_ITEMS_EQUIPMENT_READINESS_BATCH',
  handoff: 'PENDING_ITEMS_HANDOFF',
  activeHandoffs: 'PENDING_ITEMS_ACTIVE_HANDOFFS',
  recipients: 'PENDING_ITEMS_RECIPIENTS',
} as const

const READINESS_ITEM_FIELDS = `
  itemKey
  kind
  title
  reasonCode
  sitePolicyId
  policyRevisionId
  signerCapacity
  signerId
  dueOn
  validUntil
`

const DIMENSION_FIELDS = `
  status
  reasonCodes
`

const HANDOFF_FIELDS = `
  handoffId
  siteId
  clientId
  recipientSignerId
  recipientCapacity
  channel
  status
  doneCount
  totalCount
  statusVersion
  expiresAt
  resultCode
  createdAt
  updatedAt
  completedAt
  publicUrl
  items {
    itemKey
    kind
    title
    sitePolicyId
    signerCapacity
    capability
    countsTowardCompletion
    done
  }
`

const EQUIPMENT_READINESS_FIELDS = `
      siteId
      clientId
      equipmentId
      equipmentCategory
      evaluatedSiteLocalDate
      age {
        ${DIMENSION_FIELDS}
      }
      policy {
        ${DIMENSION_FIELDS}
      }
      skinType {
        ${DIMENSION_FIELDS}
      }
      operational {
        ${DIMENSION_FIELDS}
      }
      blockingItems {
        ${READINESS_ITEM_FIELDS}
      }
      actionableItems {
        ${READINESS_ITEM_FIELDS}
      }
      upcomingItems {
        ${READINESS_ITEM_FIELDS}
      }
`

export const equipmentReadinessQuery = gql`
  query PendingItemsEquipmentReadiness($siteId: ID!, $clientId: ID!, $equipmentId: ID!) {
    equipmentReadiness(siteId: $siteId, clientId: $clientId, equipmentId: $equipmentId) {
      ${EQUIPMENT_READINESS_FIELDS}
    }
  }
`

export const equipmentReadinessBatchQuery = gql`
  query PendingItemsEquipmentReadinessBatch(
    $siteId: ID!
    $requests: [EquipmentReadinessRequestInput!]!
  ) {
    equipmentReadinessBatch(siteId: $siteId, requests: $requests) {
      ${EQUIPMENT_READINESS_FIELDS}
    }
  }
`

export const createPendingItemsHandoffMutation = gql`
  mutation CreatePendingItemsHandoff(
    $siteId: ID!
    $clientId: ID!
    $recipientCapacity: SignerCapacity!
    $guardianClientId: ID
    $channel: PendingItemsChannel!
    $mobileOverride: String
    $smsConsentAttested: Boolean
    $deviceTokenId: ID
    $guardianIdChecked: Boolean
    $idempotencyKey: String!
  ) {
    createPendingItemsHandoff(
      siteId: $siteId
      clientId: $clientId
      recipientCapacity: $recipientCapacity
      guardianClientId: $guardianClientId
      channel: $channel
      mobileOverride: $mobileOverride
      smsConsentAttested: $smsConsentAttested
      deviceTokenId: $deviceTokenId
      guardianIdChecked: $guardianIdChecked
      idempotencyKey: $idempotencyKey
    ) {
      ${HANDOFF_FIELDS}
      presenceBinding
    }
  }
`

export const cancelPendingItemsHandoffMutation = gql`
  mutation CancelPendingItemsHandoff($siteId: ID!, $handoffId: ID!) {
    cancelPendingItemsHandoff(siteId: $siteId, handoffId: $handoffId) {
      ${HANDOFF_FIELDS}
    }
  }
`

export const pendingItemsHandoffQuery = gql`
  query PendingItemsHandoff($handoffId: ID!) {
    pendingItemsHandoff(handoffId: $handoffId) {
      ${HANDOFF_FIELDS}
    }
  }
`

export const activePendingItemsHandoffsQuery = gql`
  query ActivePendingItemsHandoffs($siteId: ID!, $clientId: ID!) {
    activePendingItemsHandoffs(siteId: $siteId, clientId: $clientId) {
      ${HANDOFF_FIELDS}
    }
  }
`

export const pendingItemsRecipientsQuery = gql`
  query PendingItemsRecipients($siteId: ID!, $clientId: ID!) {
    pendingItemsRecipients(siteId: $siteId, clientId: $clientId) {
      signerId
      guardianClientId
      name
      maskedMobile
      hasValidMobile
      hasTextConsent
      dobVerified
      hasAppDevice
      items {
        itemKey
        kind
        title
        signerCapacity
        blocking
        requiredForEquipment
      }
    }
  }
`
